'use strict';

module.exports = require('dibs-token-replace');



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/tokenReplace.js
// module id = 2624
// module chunks = 62